<template>
    <div>

        <v-row>
            <v-col sm="6" offset-sm="3">

                <v-card>
                    <v-card-title>Reset Password</v-card-title>
                    <v-card-text>
                        <v-form v-model="formIsValid">
                            <v-text-field
                                    label="Password"
                                    v-model="password"
                                    type="password"
                                    prepend-icon="mdi-lock"
                                    :rules="passwordRules"
                                    validate-on-blur
                                    @focus="error = null"
                                    required
                            />
                            <v-text-field
                                    label="Confirm Password"
                                    v-model="password_confirmation"
                                    type="password"
                                    prepend-icon="mdi-lock-check"
                                    :rules="passwordConfirmationRules"
                                    @focus="error = null"
                                    required
                            />
                        </v-form>
                    </v-card-text>

                    <v-alert class="mx-4" dense outlined type="error" v-if="error">{{ error }}</v-alert>
                    <v-alert class="mx-4" dense type="error" v-if="invalidToken">
                        The password reset token has expired.  <router-link to="/login">Click here to request a new password reset</router-link>.
                    </v-alert>
                    <v-alert class="mx-4" dense type="success" v-if="showConfirmation">
                        Your password has been updated.  <router-link to="/login">Click here to log in</router-link>.
                    </v-alert>
                    <v-divider></v-divider>

                    <v-card-actions class="pa-4">
                        <v-btn @click="submit()" :disabled="!formIsValid">Submit</v-btn>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>


    </div>
</template>

<script>
  export default {
    name: "ResetPassword",
    data() {
      return {
        password: '',
        password_confirmation: '',
        showError: false,
        formIsValid: false,
        error: null,
        invalidToken: false,
        showConfirmation: false,
        passwordRules: [
          value => !!value || 'Password is required',
          value => value.length >= 8 || 'Password must be at least 8 characters'
        ],
        passwordConfirmationRules: [
          value => !!value || 'Password confirmation is required',
          value => value.length >= 8 || 'Password confirmation must be at least 8 characters',
          value => value === this.password || 'Password and confirmation do not match'
        ],
      }
    },
    methods: {
      submit() {
        if (!this.password || !this.password_confirmation) {
          return;
        } else {
          this.$store.dispatch('resetPassword', {
            email: this.$route.query.email,
            token: this.$route.query.token,
            password: this.password,
            password_confirmation: this.password_confirmation
          }).then(response => {
            if (response.data && response.data.success && response.data.success === 'false') {
              if (response.data.message && response.data.message === 'INVALID TOKEN') {
                this.invalidToken = true;
              }
            }
            if (response.data && response.data.success && response.data.success === 'true') {
              this.showConfirmation = true;
            }
          })
        }
      }
    },
    created() {
      if (!this.$route.query.email || !this.$route.query.token) {
        this.$router.push({ name: 'Login' })
      }
    }
  }
</script>

<style scoped>

</style>
